import React, { useEffect, useState } from "react";
import { Box, Chip, Stack, TextField } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import GlobalWrapper from "../../../../../components/Wrapper/GlobalWrapper";
import { useLocation, useNavigate } from "react-router-dom";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import GlobalDatagrid from "../../../../../components/mui/DataGrid/GlobalDatagrid";
import { Student_Attendace_Head } from "../../../../../components/datagrid/CRD/NewAdmissionRegister/StudentAttendanceTableHead";
import { getStudentAttendanceView } from "../../../../../redux/features/CRDslice";
import { savePaginationData } from "../../../../../redux/features/globalDatagridSlice";

const StudentAttendanceView = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const admissionNo = searchParams.get("admissionNo");
  const studentName = searchParams.get("studentName");
  const course = searchParams.get("course");
  const total_sessions = searchParams.get("total_sessions");
  const courseEnrollmentId = searchParams.get("courseEnrollmentId");

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { paginationData } = useSelector((state) => state.globalDataGrid);
  const { gridSize, pageNum, rowData, openAnchor, search } = paginationData;

  const { loading, studentAttendanceView } = useSelector((state) => state.crd);

  const [value, setValue] = useState(dayjs());

  const [month, setmonth] = useState(dayjs(value).format("MM"));
  const [year, setyear] = useState(dayjs(value).format("YYYY"));

  const data = {
    page: pageNum,
    limit: gridSize,
    course_enrollment_id: courseEnrollmentId,
    year: year,
    month: month,
  };

  useEffect(() => {
    if (pageNum && gridSize) {
      dispatch(
        savePaginationData({
          ...paginationData,
          openAnchor: false,
        })
      );
      dispatch(getStudentAttendanceView(data));
    }
  }, [pageNum, gridSize, year, month]);

  return (
    <GlobalWrapper title={"Student Attendance View"}>
      <Box sx={{ width: "100%", padding: 0 }}>
        <Stack
          direction={{
            xs: "column",
            sm: "row",
          }}
          spacing={1}
          paddingBottom={1}
        >
          <Box
            sx={{
              backgroundImage: "linear-gradient(to right,#8FA6CB,#7D84B2)",
              px: "12px",
              py: "5px",
              borderRadius: "15px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "white",
              fontSize: "14px",
            }}
          >
            Admission No : {admissionNo}
          </Box>
          <Box
            sx={{
              backgroundImage: "linear-gradient(to right,#8FA6CB,#7D84B2)",
              px: "12px",
              py: "5px",
              borderRadius: "15px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "white",
              fontSize: "14px",
            }}
          >
            Student Name : {studentName}
          </Box>
          <Box
            sx={{
              backgroundImage: "linear-gradient(to right,#8FA6CB,#7D84B2)",
              px: "12px",
              py: "5px",
              borderRadius: "15px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "white",
              fontSize: "14px",
            }}
          >
            Course : {course}
          </Box>
          <Box
            sx={{
              backgroundImage: "linear-gradient(to right,#538083,#538083)",
              px: "12px",
              py: "5px",
              borderRadius: "15px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "white",
              fontSize: "14px",
            }}
          >
            Total Sessions : {total_sessions}
          </Box>
        </Stack>
        <Stack
          direction={{
            xs: "column",
            sm: "row",
          }}
          spacing={1}
          paddingBottom={3}
        >
          {studentAttendanceView?.meta?.attendanceTypeCounts?.map((item) => (
            <Chip
              label={`${item.attendance_type_name} : ${item.attendance_count}`}
              color="secondary"
              variant="contained"
              key={item.attendance_type_id}
            />
          ))}
        </Stack>
      </Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "flex-start",
          pb: 2,
          gap: 2,
        }}
      >
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePicker
            label="Select Month"
            value={dayjs(value)}
            onChange={(newValue) => {
              setmonth(dayjs(newValue).format("MM"));
            }}
            format="MMMM"
            views={["month"]}
            renderInput={(params) => <TextField {...params} />}
          />
        </LocalizationProvider>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePicker
            label="Select Year"
            value={dayjs(value)}
            onChange={(newValue) => {
              setyear(dayjs(newValue).format("YYYY"));
            }}
            format="YYYY"
            views={["year"]}
            renderInput={(params) => <TextField {...params} />}
          />
        </LocalizationProvider>
      </Box>
      <Box sx={{ width: "100%", padding: 0 }}>
        <GlobalDatagrid
          tableHead={Student_Attendace_Head(
            navigate,
            month,
            year,
            courseEnrollmentId
          )}
          rows={studentAttendanceView?.data}
          meta={studentAttendanceView?.meta?.totalRecords || 0}
          loading={loading}
          rowUniqueId="sl_no"
          rowClick={false}
          actionComponent={<></>}
        />
      </Box>
    </GlobalWrapper>
  );
};

export default StudentAttendanceView;
